import { Padrao } from '../generic/padrao';

export class Funcao extends Padrao{

    override idTab = 18;

    nome: string;
}